import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/header_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-5b72f0f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logoClass" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "header_logo",
    src: _imports_0,
    alt: "logo"
  })
], -1))
const _hoisted_3 = { class: "header_container" }
const _hoisted_4 = {
  key: 0,
  class: "header_center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, " | ", -1))
const _hoisted_6 = {
  key: 1,
  class: "header_login"
}

import Login from '@/components/login.vue'
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'
import {reactive, ref} from 'vue';
import {ElMessageBox} from 'element-plus'
import {ElMessage} from 'element-plus'

// 获取apiUrl

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

// 导入实例
const store: any = useStore();
// 登录弹窗
const loginRef = ref();
const showLogin = () => {
  loginRef.value.entryVisible = true
};
// 获取参数
const router: any = useRouter();
const logOut:any = () => {
  ElMessageBox.confirm(
      '您确认退出登录吗?',
      '提示',
      {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }
  )
      .then(() => {
        quitHandle()
      })
      .catch(() => {})
}
// 退出事件
const quitHandle: any = () => {
  ElMessage.success('退出成功!');
  data.logged = false;
  store.state.logged = false;
  data.linkItems[1].show = false;
  store.state.userData = null;
  //sessionStorage.removeItem('userData');
  window.sessionStorage.clear()
  router.replace('/');
}

const data: any = reactive({
  logged: store.state.logged,
  linkItems: [
    {
      name: '首页',
      link: '/',
      show: true,
    },
    {
      name: '资源中心',
      link: '/ResourceCenter',
      show: store.state.logged,
    },
    {
      name: '文档中心',
      link: '/DocumentCenter',
      show: false,
    },
    {
      name: '平台公告',
      link: '/platformAnnouncement',
      show: false,
    },
    {
      name: '联系我们',
      link: '/contactUs',
      show: false,
    },
  ],
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.linkItems, (item) => {
          return _withDirectives((_openBlock(), _createBlock(_component_router_link, {
            key: item,
            to: item.link
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])), [
            [_vShow, item.show]
          ])
        }), 128))
      ]),
      (_unref(store).state.logged)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/basicInformation" }, {
              default: _withCtx(() => [
                _createTextVNode("个人中心")
              ]),
              _: 1
            }),
            _hoisted_5,
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (logOut()))
            }, "退出")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("a", { onClick: showLogin }, "登录")
          ]))
    ]),
    _createVNode(Login, {
      ref_key: "loginRef",
      ref: loginRef
    }, null, 512)
  ]))
}
}

})